import { type MCPServerInfo } from '../../types';

const ZoomRemoteServer: MCPServerInfo = {
  serverId: 'ZOOM_REMOTE',
  name: 'Zoom',
  slug: 'zoom-remote',
  description:
    'Official Zoom remote MCP server. Search meetings, access recordings and transcripts, manage Zoom Docs, and search across chat and docs.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.zoom.us/mcp/zoom/streamable',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default ZoomRemoteServer;
